module.exports = __webpack_public_path__ + "img/login-image.6723cf8b.png";